module.exports = __webpack_public_path__ + "static/team-7-ff31ea0350e5dc3ba76878db1ed67bf7.png";